<template>
  <AccessedContainer />
  <UnAccessedContainer />
  <div class="pb-4"></div>
</template>
<script>
import { AccessedContainer, UnAccessedContainer } from "./exporter.js";
export default {
  name: "dashboard-default",
  components: {
    AccessedContainer,
    UnAccessedContainer,
  },
};
</script>
